import { render, staticRenderFns } from "./ActPrintPayment.vue?vue&type=template&id=5cf9b94e&scoped=true"
import script from "./ActPrintPayment.vue?vue&type=script&lang=js"
export * from "./ActPrintPayment.vue?vue&type=script&lang=js"
import style0 from "./ActPrintPayment.vue?vue&type=style&index=0&id=5cf9b94e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf9b94e",
  null
  
)

export default component.exports